import service from '@/store/services/employers/permits-service';

const state = {
    list: {},
    permit: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, permit) => {
        state.permit = permit;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(permit => {
                commit('SET_RESOURCE', permit);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(permit => {
                commit('SET_RESOURCE', permit);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((permit) => {
                commit('SET_RESOURCE', permit);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((permit) => {
                commit('SET_RESOURCE', permit);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    permit: state => state.station,
    dropdown: (state) => {
        return state.list.map(permit => ({
            id: permit.id,
            name: permit.name,
        }));
    }
};

const permits = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default permits;
